import * as React from 'react';

import {providers} from '@logilab/cwclientlibjs';
import {filterWithTextSearch} from './SearchBar';
import {compareNamedEntities} from '../commons';
import {RelationOrAttribute} from './useSchemaNavigator';

interface RelationsAndAttributesListProps {
    relations: {
        from: providers.EntityRelationSchema[];
        to: providers.EntityRelationSchema[];
    };
    attributes: providers.EntityAttributeSchema[];
    tempSelectedRelationOrAttribute: string | null;
    setTempSelectedRelationOrAttribute: (name: string | null) => void;
    deselectTempRelationOrAttribute: () => void;
    selectedRelationName: string | null;
    selectRelationOrAttribute: (name: string) => void;
    selectedAttributeName: string | null;
    textSearch: string;
}

export class RelationsAndAttributesList extends React.Component<RelationsAndAttributesListProps> {
    constructor(props: Readonly<RelationsAndAttributesListProps>) {
        super(props);
        this.state = {textSearch: ''};
    }
    private renderRelationsList(
        relList: RelationOrAttribute[],
        renderRelationItem: (rel: RelationOrAttribute) => JSX.Element
    ): JSX.Element {
        return (
            <ul>
                {relList.map((relation) => (
                    <li
                        onMouseOver={() =>
                            this.props.setTempSelectedRelationOrAttribute(
                                relation.name
                            )
                        }
                        onMouseOut={() =>
                            this.props.deselectTempRelationOrAttribute()
                        }
                        onClick={() =>
                            this.props.selectRelationOrAttribute(relation.name)
                        }
                        className={
                            (this.props.selectedRelationName !== null &&
                                relation.name ===
                                    this.props.selectedRelationName) ||
                            (this.props.selectedAttributeName !== null &&
                                relation.name ===
                                    this.props.selectedAttributeName)
                                ? 'selected'
                                : ''
                        }
                        key={relation.eid}
                    >
                        {renderRelationItem(relation)}
                    </li>
                ))}
            </ul>
        );
    }

    private renderRelations() {
        const filteredRelationsFrom = filterWithTextSearch(
            this.props.textSearch,
            this.props.relations.from
        ).sort(compareNamedEntities);
        const filteredRelationsTo = filterWithTextSearch(
            this.props.textSearch,
            this.props.relations.to
        ).sort(compareNamedEntities);
        const filteredAttributes = filterWithTextSearch(
            this.props.textSearch,
            this.props.attributes
        ).sort(compareNamedEntities);
        return (
            <div className="relations-list">
                {this.renderRelationsList(filteredRelationsFrom, (rel) => (
                    <>
                        <span>{rel.name}</span>
                        <span className="arrow">{'◀——'}</span>
                    </>
                ))}
                {this.renderRelationsList(filteredRelationsTo, (rel) => (
                    <>
                        <span>{rel.name}</span>
                        <span className="arrow">{'——▶'}</span>
                    </>
                ))}
                {this.renderRelationsList(
                    filteredAttributes,
                    (attribute: providers.EntityAttributeSchema) => (
                        <>
                            <span>{attribute.name}</span>
                            <span className="attribute-type">
                                {attribute.type}
                            </span>
                        </>
                    )
                )}
            </div>
        );
    }

    render() {
        return <div className="column-content">{this.renderRelations()}</div>;
    }
}
